(function () {
  function parseIds(attr) {
    if (!attr) return [];
    return String(attr).split(',').map(s => s.trim()).filter(Boolean);
  }

  function showForVariant(variantId) {
    const items = document.querySelectorAll('.product-media__item');
    if (!items.length) return;

    items.forEach(el => {
      const isGeneric = el.getAttribute('data-generic') === 'true';
      const ids = parseIds(el.getAttribute('data-variant-ids'));
      if (isGeneric || ids.includes(String(variantId))) {
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });

    const firstVisible = Array.from(items).find(el => el.style.display !== 'none');
    if (firstVisible && firstVisible.scrollIntoView) {
      try { firstVisible.scrollIntoView({ block: 'nearest' }); } catch (e) {}
    }
  }

  function getCurrentVariantId(scope) {
    const root = scope || document;
    const input = root.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input ? input.value : null;
  }

  function initVariantWatcher() {
    let lastId = null;

    // Themes modernes déclenchent 'variant:change'
    window.addEventListener('variant:change', e => {
      const id = e?.detail?.variant?.id || getCurrentVariantId();
      if (id && id !== lastId) {
        lastId = id;
        showForVariant(id);
      }
    });

    // Fallback universel: surveille la valeur du <input name="id">
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput) {
      const obs = new MutationObserver(() => {
        const id = getCurrentVariantId();
        if (id && id !== lastId) {
          lastId = id;
          showForVariant(id);
        }
      });
      obs.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }

    // Initialisation
    const startId = getCurrentVariantId();
    if (startId) {
      lastId = startId;
      showForVariant(startId);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantWatcher);
  } else {
    initVariantWatcher();
  }
})();
